export default "__VITE_PUBLIC_ASSET__6d3ad953__"